import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function users(state=initialState.users, action) {
    switch (action.type) {
        case appConstants.ALL_USERS_SUCCESS:
            return Object.assign({}, state, action.users);
        default:
            return state
    }
}
